
import {Component, Watch} from 'vue-property-decorator';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import SecondaryLineBarChartFilterable from '@/components/reports-v3/components/filterables/SecondaryLineBarChartFilterable.vue';
import TiarcoChemicalMYearlyComparison from '@/components/reports-v3/components/codedWidgets/custom/tiarco/TiarcoChemicalMYearlyComparison.vue';
import TiarcoChemicalMMonthlyComparison from '@/components/reports-v3/components/codedWidgets/custom/tiarco/TiarcoChemicalMMonthlyComparison.vue';
import TiarcoChemicalMOtherIncomeBreakdownTable from '@/components/reports-v3/components/codedWidgets/custom/tiarco/TiarcoChemicalMOtherIncomeBreakdownTable.vue';
import TiarcoYearlySalesAnalysisByItemCode from '@/components/reports-v3/components/codedWidgets/custom/tiarco/TiarcoYearlySalesAnalysisByItemCode.vue';

@Component({
  components: {
      TiarcoYearlySalesAnalysisByItemCode,
    TiarcoChemicalMOtherIncomeBreakdownTable,
    TiarcoChemicalMMonthlyComparison,
    TiarcoChemicalMYearlyComparison,
    SecondaryLineBarChartFilterable,
  },
})

export default class TiarcoChemicalDashboard extends FilterWidget {

}
